import React from 'react'
import ProgressUI from '../../widgets/output/ProgressUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import LabelAndValueUI from '../../widgets/layout/LabelAndValueUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import ZTransactionListUI from '../../components/finapp/bankAccount/ZTransactionListUI'
import ZTransactionHeaderUI from '../../components/finapp/bankAccount/ZTransactionHeaderUI'
// import './TransactionListPage.css'

const ZTransactionListPageUI = ({ context, errorList, txnList, filteredTxnList,
  searchFilter, onRefreshClick, onSearchFilterChange, bankAccountList,
  hasMore, onMoreTransactions, gettingMore,
  downloadMode, onDownloadClick, onDownloadCancel, bankAccountNumber
}) =>
  <PrivatePageSF context={context} className='pg_txns' backLink='/home'
    headerText='Transactions'
    centered={!txnList && !errorList}
  >
    {
      !txnList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      txnList &&
      <PageTitleUI context={context} goBack={true} backLink='/home' titleText='Transactions' />
    }
    {
      bankAccountList && txnList &&
      <ZTransactionHeaderUI context={context} bankAccountList={bankAccountList} onRefreshClick={onRefreshClick} />
    }
    {
      txnList && txnList.length === 0 &&
      <EmptyListUI
        context={context}
        createDisabledMessageLabel='No transactions'
      />
    }
    {
      txnList && filteredTxnList && txnList.length !== 0 &&
      <ZTransactionListUI
        context={context}
        txnList={filteredTxnList}
        searchFilter={searchFilter}
        onRefreshClick={onRefreshClick}
        onSearchFilterChange={onSearchFilterChange}
        hasMore={hasMore}
        onMoreTransactions={onMoreTransactions}
        gettingMore={gettingMore}
        downloadMode={downloadMode}
        onDownloadClick={onDownloadClick}
        onDownloadCancel={onDownloadCancel}
        bankAccountNumber={bankAccountNumber}
      />
    }
  </PrivatePageSF>

export default ZTransactionListPageUI
